import { useContext } from "react";
import InputContext from "../context";

export const useInputs = () => {
  return useContext(InputContext);
};
